export default "__VITE_ASSET__Bbbu3iWc__"